import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import { Tabs, AppBar, Tab } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useMediaQuery } from "react-responsive";
import Modal from "@material-ui/core/Modal";
import CancelIcon from "@material-ui/icons/Cancel";

import { Context as InvoicesContext } from "../context/invoices.context.js";
import { Context as PortalContext } from "../context/portal.context.js";
import { Context as AuthContext } from "../context/auth.context.js";
import MyTableRow from "./TableRow.js";
import ConfirmPaymentBar from "./ConfirmPaymentBar";
import Invoice from "../pages/Invoice";

import Button from "@material-ui/core/Button";
import DecimalsOnly from "../helpers/DemicalsOnly";
import PaymentMethod from "../helpers/PaymentMethod";
import Thousands from "../helpers/Thousands";

import axios from "axios";

import UsageChart from "./UsageChart";

import getExternalProviderTransactions from "../api/ExternalProviders";
import { isPast } from "date-fns";

const data = {
  labels: [
    "Jan 2020",
    "Feb 2020",
    "Mar 2020",
    "Apr 2020",
    "May 2020",
    "Jun 2020",
    "Jul 2020",
    "Aug 2020",
    "Sep 2020",
    "Oct 2020",
    "Nov 2020",
    "Dec 2020",
  ],
  datasets: [
    {
      data: [1400, 1100, 250, 275, 350, 456, 600, 250, 0, 0, 900, 1500],
      backgroundColor: ["#EE9C03"],
    },
  ],
};

const options = {
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

const qs = require("qs");

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { state } = React.useContext(PortalContext);

  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    invoices,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  //console.log("ExternalProvider: %o", state);
  const headCells =
    state.externalProvider == "daffron"
      ? [
          {
            id: "date",
            numeric: false,
            disablePadding: false,
            label: "Date",
          },
          {
            id: "description",
            numeric: false,
            disablePadding: false,
            label: "Description",
          },
          {
            id: "paid",
            numeric: false,
            disablePadding: true,
            label: "",
          },
          {
            id: "due",
            numeric: false,
            disablePadding: false,
            label: "Due",
          },
          {
            id: "status",
            numeric: false,
            disablePadding: false,
            label: "Status",
          },
          {
            id: "action",
            numeric: false,
            disablePadding: false,
            label: "",
          },
        ]
      : isTabletOrMobile
      ? [
          {
            id: "date",
            numeric: false,
            disablePadding: false,
            label: "Date",
          },
          {
            id: "due",
            numeric: false,
            disablePadding: false,
            label: "Due",
          },
          {
            id: "description",
            numeric: false,
            disablePadding: false,
            label: "Description",
          },
          {
            id: "paid",
            numeric: false,
            disablePadding: false,
            label: "Paid",
          },

          {
            id: "status",
            numeric: false,
            disablePadding: false,
            label: "Status",
          },
          {
            id: "action",
            numeric: false,
            disablePadding: false,
            label: "",
          },
        ]
      : [
          {
            id: "date",
            numeric: false,
            disablePadding: false,
            label: "Date",
          },
          {
            id: "description",
            numeric: false,
            disablePadding: false,
            label: "Description",
          },
          {
            id: "paid",
            numeric: false,
            disablePadding: false,
            label: "Paid",
          },
          {
            id: "due",
            numeric: false,
            disablePadding: false,
            label: "Due",
          },
          {
            id: "status",
            numeric: false,
            disablePadding: false,
            label: "Status",
          },
          {
            id: "action",
            numeric: false,
            disablePadding: false,
            label: "",
          },
        ];

  return (
    <TableHead
      style={{
        backgroundColor: "rgb(236, 241, 246)",
      }}
    >
      <TableRow data={props.data}>
        {state.invoice_interface !== "amount" && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === invoices.length}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  const paymentTotal = props.paymentTotal;

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  return (
    <>
      <Toolbar
        className={clsx(classes.root)}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          height: 85,
          paddingLeft: 25,
          paddingRight: 25,
        }}
      >
        <Typography
          variant="h6"
          id="tableTitle"
          component="div"
          style={{ color: props.theme.palette.primary.main }}
        >
          <x-lang>Invoices</x-lang>
        </Typography>
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [allAvailableSelected, setAllAvailableSelected] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [openInvoiceModal, setOpenModal] = React.useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [count, setCount] = React.useState(0);
  const [rows, setRows] = React.useState([]);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [paymentTotal, setPaymentTotal] = React.useState(0.0);
  const [invoices, setInvoices] = React.useState("");

  const authState = React.useContext(AuthContext);
  const portalState = React.useContext(PortalContext);
  const {
    state,
    getInvoices,
    paidYrToDate,
    // setPaymentTotal,
    // setSelectedInvoices,
  } = React.useContext(InvoicesContext);
  const [value, setValue] = React.useState(0);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  useEffect(() => {
    //console.log("SELECTED INVOICES", state.invoices);
    if (isTabletOrMobile) {
      setRowsPerPage(3);
    }
    if (authState.state.authenticated && portalState.state.portalHydrated) {
      getInvoices({
        merchantID: authState.state.merchantID,
        customerID: authState.state.customerID,
      });

      // console.log(
      //   "INTELLIPAY YO",
      //   document.getElementById("intellipay-lightbox")
      // );

      getLightbox({
        buttonColor: props.theme.palette.secondary.main,
        customerID: authState.state.customerID,
        merchantID: authState.state.merchantID,
        enpartialpayment: portalState.state.allowPartialPayment,
      });

			if(typeof portalState.state.externalProvider !== 'undefined' && portalState.state.externalProvider !== ''){
				getExternalProviderTransactions({ setData: setInvoiceData });
			}
      return () => {
        if (document.getElementById("intellipay-lightbox") !== null) {
          document.getElementById("intellipay-lightbox").remove();
        }

        var elements = document.getElementsByClassName("intellipay-md-overlay");
        for (var i = 0; i < elements.length; i++) {
          elements[i].remove();
        }
      };
    }
  }, [authState.state.authenticated]);

  useEffect(() => {
    // console.log("IN THIS EFFECT");
    // console.log("This hello", selected);
    // return () => {
    //   console.log("IN EVENT LISTENER REMOVE");
    //   window.removeEventListener("message", (message) => {
    //     receiveMessage(message);
    //   });
    // };
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);

  const refreshLightbox = async ({
    buttonColor,
    customerID,
    merchantID,
    enpartialpayment,
  }) => {
    setSelected([]);
    setPaymentTotal(0.0);

    const options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        merchantID,
        customerID,
        method: "refreshLightbox",
        params: `{merchantID: ${merchantID}}`,
      }),
      withCredentials: true,
    };

    const intellipayResponse = await axios(options);
    // console.log("REFRESH RESPONSE", window.intellipay);
    // console.log("REFRESH REPONSE", intellipayResponse.data.lightbox);
    eval(intellipayResponse.data.lightbox);
    window.intellipay.auth.enpartialpayment = enpartialpayment;
    window.intellipay.auth.isFullAccount = authState.state.isFullAccount;
    window.intellipay.auth.isCustPortal = true;
    window.intellipay.enable("email");
    getInvoices();

    //intellipayResponse.data.lightbox;

    //window.intellipay = null;

    //console.log

    //window.intellipay = intellipayResponse.data.lightbox;
  };

  const getLightbox = async ({
    buttonColor,
    customerID,
    merchantID,
    enpartialpayment,
  }) => {
    const options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify({
        merchantID,
        customerID,
        method: "openLightbox",
        params: `{merchantID: ${merchantID}}`,
      }),
      withCredentials: true,
    };

    const intellipayResponse = await axios(options);

    // console.log('GET LIGHTBOX RESPONSE', intellipayResponse);

    if (document.getElementById("intellipay-lightbox") === null) {
      var rg = document.createRange();
      document.documentElement.appendChild(
        rg.createContextualFragment(intellipayResponse.data.lightbox)
      );
    }

    window.intellipay.initialize();
    window.intellipay.auth.enpartialpayment = enpartialpayment;
    window.intellipay.auth.isCustPortal = true;
    window.intellipay.auth.isFullAccount = authState.state.isFullAccount;
    window.intellipay.setItemLabel("account", "Account #");
    window.intellipay.enable("email");
    window.intellipay.setItemBackgroundColor("button", buttonColor);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    // console.log('event', event.target);
    // console.log('checked?', event.target.checked);

    // console.log('allAvailableSelected', state.allAvailableSelected);

    // if (event.target.checked) {
    if (!allAvailableSelected) {
      const newSelecteds = state.invoices
        .filter(function (i) {
          if (i.due != 0) {
            return i;
          }
        })
        .map((n) => n);
      // const newSelecteds = state.invoices.map((n) => n);

      setAllAvailableSelected(true);

      setSelected(newSelecteds);
      console.log("selected", newSelecteds);
      var overDue = 0;

      /* if (typeof(state.overDue) != "undefined") {
				console.log("Anuja ExernalProvider: %o", portalState.state.externalProvider);
				console.log("Anuja overDue: %o", state.overDue);
			}
			if (typeof(state.overDue) != "undefined" && portalState.state.externalProvider == 'daffron') {
				overDue += parseFloat(state.overDue);
			}
			setPaymentTotal(parseFloat(setTotal(newSelecteds)) + overDue);
			 */
			setPaymentTotal(setTotal(newSelecteds));
			return;
		} 

		setAllAvailableSelected(false);
		setSelected([]);
		setPaymentTotal(0.0);
	};

	const handleClick = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleOpenModal = () => {
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};


	const setTotal = (arr) => {
		let total = 0;

		for (var index in arr) {
			total += parseFloat(arr[index]['due']);
		}
		return total.toFixed(2);
	};

	const createInvoicesString = () => {

		let invoicesString = [];
		
		//In the event that using invoice_interface amount push all unpaid invoice to the invoice string
		if(portalState.state.invoice_interface === 'amount'){
			state.invoices.forEach((i, index) => {
				if(
					typeof(i.overdue) != "undefined" ||
					isPast(new Date(i.dueDate)) && i.paid == false ||
					isPast(new Date(i.dueDate)) && i.paid < i.due ||
					i.status.toLowerCase() != 'paid' 

				){
					invoicesString.push(i.id);
				}
			});
		} else {
			for (var i = 0; i < selected.length; i++) {
				invoicesString.push(selected[i].id);
			}
		}

		// console.log("STRING", invoicesString.join());

		return invoicesString.join();
	};

	const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

	return (
		<div className={classes.root}>


			{ typeof portalState.state.externalProvider != "undefined" && portalState.state.externalProvider == "daffron" &&
				typeof portalState.state.custom_message != "undefined" && portalState.state.custom_message != null &&
				portalState.state.custom_message != "" && (
				<>
					<div style={{border: "2px solid black", padding:"15px", fontWeight:"bold", borderRadius:"5px",
					backgroundColor:"#f1bac9"}}>
						{portalState.state.custom_message}
					</div>
					<p/>
				</>
			)}

			{ typeof portalState.state.externalProvider != "undefined" && portalState.state.externalProvider == "daffron" && (
				<>
					<div style={{border: "2px solid black", padding:"15px", fontWeight:"bold", borderRadius:"5px",
						backgroundColor:"#f3f55c"}}>
						<x-lang>Payments may take a couple of minutes to post to your account.</x-lang>
					</div>
					<p/>
				</>
			)}

			<Paper
				className={classes.paper}
				elevation={0}
				style={{
					width: '100%',
					boxSizing: 'border-box',
					border: '1px solid #e3e6e7',
				}}
			>
				<EnhancedTableToolbar
					numSelected={selected.length}
					theme={props.theme}
				/>
				<TableContainer
					style={{
						paddingLeft: 25,
						paddingRight: 25,
						boxSizing: 'border-box',
					}}
				>
					<Table
						className={classes.table}
						aria-labelledby="tableTitle"
						size={dense ? 'small' : 'medium'}
						aria-label="enhanced table"
					>
						<EnhancedTableHead
							classes={classes}
							numSelected={selected.length}
							order={order}
							orderBy={orderBy}
							onSelectAllClick={handleSelectAllClick}
							onRequestSort={handleRequestSort}
							rowCount={state.invoices.length}
							invoices={state.invoices}
							data={invoiceData}
						/>
						<TableBody>
							{stableSort(
								state.invoices,
								getComparator(order, orderBy)
							)
								.slice(
									page * rowsPerPage,
									page * rowsPerPage + rowsPerPage
								)
								.map((row, index) => {
									return (
										<MyTableRow
											row={row}
											setInvoices={setInvoices}
											setTotal={setTotal}
											index={index}
											setSelected={setSelected}
											selected={selected}
											setPaymentTotal={setPaymentTotal}
											openInvoiceModal={openInvoiceModal}
											handleOpenModal={handleOpenModal}
											handleCloseModal={handleCloseModal}
											key={row.id}
											data={invoiceData}
										/>
									);
								})}
							{state.invoices.length === 0 && (
								<>
								<tr><td colspan="6"><h3><x-lang>No Pending Invoices</x-lang></h3></td></tr>
								</>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				{isTabletOrMobile || state.invoices.length === 0 ? null : (
					<TablePagination
						rowsPerPageOptions={[3, 10, 25]}
						component="div"
						count={state.invoices.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onChangePage={handleChangePage}
						onChangeRowsPerPage={handleChangeRowsPerPage}
						style={{ padding: 25, boxSizing: 'border-box' }}
					/>
				)}
				{isTabletOrMobile && state.invoices.length > 3 ? (
					<Button
						color="secondary"
						style={{ marginTop: 20, marginBottom: 20 }}
						onClick={() => {
							if (rowsPerPage !== state.invoices.length) {
								setRowsPerPage(state.invoices.length);
							} else {
								setRowsPerPage(3);
							}
						}}
					>
						{rowsPerPage !== state.invoices.length
							? 'View All Invoices'
							: 'Hide Invoices'}
					</Button>
				) : null}
			</Paper>
			{state.invoices.length === 0 ? null : (
				<ConfirmPaymentBar
					amount={paymentTotal}
					setPaymentTotal={setPaymentTotal}
					selectedInvoices={selected.length}
					theme={props.theme}
					oneUnpaidInvoiceChecked={selected.filter(function(i){ if (i.status != "paid" && i.status != "Paid") {return i;}}).map((n) => n).length >= 1}
				/>
			)}

			{portalState.state.externalProvider === 'caselle' && <UsageChart />}

			<Modal
				open={openInvoiceModal}
				onClose={handleCloseModal}
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					outline: 'none',
				}}
			>
				<Paper
					elevation={3}
					style={{
						height: 'calc(100vh - 50px)',
						width: 'auto',
						overflowY: 'auto',
						background: 'white',
						outline: 'none',
						borderRadius: 5,
						position: 'relative',
					}}
				>
					<IconButton
						style={{ position: 'absolute', top: 15, right: 15 }}
						onClick={handleCloseModal}
					>
						<CancelIcon />
					</IconButton>
					<Invoice data={invoiceData} />
				</Paper>
			</Modal>

			{(paymentTotal === '0' ||
			paymentTotal === '0.00' ||
			paymentTotal === 0 ) &&
			!portalState.state.allowPartialPayment 
			? (
				<input
					className="ipayfield"
					id="intellipay-amount-hidden"
					data-ipayname="amount"
					type="hidden"
					value={parseFloat(state.totalDue).toFixed(2)}
				/>
			) : (
				<input
					className="ipayfield"
					id="intellipay-amount-hidden"
					data-ipayname="amount"
					type="hidden"
					value={(paymentTotal == 0 && portalState.state.allowPartialPayment ) ? 0.00 : paymentTotal}
				/>
			)}

			<input
				className="ipayfield"
				data-ipayname="account"
				type="hidden"
				value={
					authState.state.accountNumber
						? authState.state.accountNumber
						: ''
				}
			/>
			<input
				className="ipayfield"
				data-ipayname="invoices"
				type="hidden"
				value={createInvoicesString()}
			/>
			{/* <input
          className="ipayfield"
          data-ipayname="invoice"
          type="hidden"
          value={authState.state.accountNumber}
        /> */}
      <input
        className="ipayfield"
        data-ipayname="firstname"
        type="hidden"
        value={authState.state.firstName ? authState.state.firstName : ""}
      />
      <input
        className="ipayfield"
        data-ipayname="lastname"
        type="hidden"
        value={authState.state.lastName ? authState.state.lastName : ""}
      />
      <input
        className="ipayfield"
        data-ipayname="email"
        type="hidden"
        value={authState.state.email ? authState.state.email : ""}
      />
    </div>
  );
}

{
  /* <Paper
          className={classes.paper}
          elevation={0}
          style={{
            padding: 25,
            paddingTop: isTabletOrMobile ? 25 : 0,
            width: "100%",
            border: "1px solid #e3e6e7",
          }}
        >
          {isTabletOrMobile ? (
            <h3
              style={{
                color: props.theme.palette.primary.main,
                fontSize: 16,
                margin: 0,
                textAlign: "left",
                marginBottom: 10,
                borderBottom: "1px solid #ddd",
                paddingBottom: 10,
              }}
            >
              {state.invoices.length === 0
                ? "No Invoices Due"
                : "Current Invoices Due "}
            </h3>
          ) : (
            <EnhancedTableToolbar
              numSelected={selected.length}
              paymentTotal={paymentTotal}
              invoices={state.invoices}
            />
          )}

          {state.invoices.length === 0 ? null : (
            <TableContainer>
              <Table
                className={classes.table}
                style={{
                  width: "100%",
                  overflow: "none",
                  minWidth: isTabletOrMobile ? 0 : 740,
                }}
                aria-labelledby="tableTitle"
                size={"small"}
                aria-label="enhanced table"
              >
                {isTabletOrMobile ? null : (
                  <EnhancedTableHead
                    classes={classes}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={state.invoices.length}
                  />
                )}
                {isTabletOrMobile ? (
                  <div
                    style={{
                      height: 80,
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #ddd",
                      paddingBottom: 10,
                    }}
                  >
                    <div>
                      <h5 style={{ color: "#fbfbfb", margin: 0, marginBottom: 5 }}>
                        Total Amount
                      </h5>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontWeight: "400",
                          alignItems: "flex-start",
                        }}
                      >
                        <sup
                          style={{
                            fontSize: 20,
                            color:
                              paymentTotal.toString() === "0" ||
                              paymentTotal.toString() === "0.00"
                                ? "#d3dce0"
                                : "#2f343b",
                          }}
                        >
                          $
                        </sup>
                        <span
                          style={{
                            color:
                              paymentTotal.toString() === "0" ||
                              paymentTotal.toString() === "0.00"
                                ? "#d3dce0"
                                : "#2f343b",
                            fontSize: 25,
                          }}
                        >
                          {paymentTotal.toString() === "0" ||
                          paymentTotal.toString() === "0.00"
                            ? "0"
                            : Thousands(Math.trunc(paymentTotal))}
                        </span>
                        <sup
                          style={{
                            fontSize: 20,
                            color:
                              paymentTotal.toString() === "0" ||
                              paymentTotal.toString() === "0.00"
                                ? "#d3dce0"
                                : "#2f343b",
                          }}
                        >
                          {paymentTotal.toString() === "0" ||
                          paymentTotal.toString() === "0.00"
                            ? ".00"
                            : paymentTotal
                                .toString()
                                .slice(
                                  paymentTotal.length - 3,
                                  paymentTotal.length
                                )}
                        </sup>
                      </div>
                    </div>
                    <div>
                      <h5 style={{ color: "#fbfbfb", margin: 0, marginBottom: 5 }}>
                        Invoices
                      </h5>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontWeight: "400",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 25,
                            color:
                              paymentTotal.toString() === "0" ||
                              paymentTotal.toString() === "0.00"
                                ? "#d3dce0"
                                : "#2f343b",
                          }}
                        >
                          {selected.length}
                        </span>
                      </div>
                    </div>
                    <Button
                      variant="contained"
                      color="secondary"
                      data-ipayname="submit"
                      className="ipayfield"
                      disabled={
                        paymentTotal === 0 || paymentTotal === "0.00"
                          ? true
                          : false
                      }
                      style={{ color: "white", borderRadius: 25 }}
                    >
                      Pay
                    </Button>
                  </div>
                ) : null}
                {state.invoices.length < 1 ? (
                  <TableBody style={{ width: "100%" }}>
                    <TableRow
                      style={{ height: (dense ? 33 : 53) * emptyRows }}
                    ></TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody>
                      {stableSort(state.invoices, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <MyTableRow
                              row={row}
                              setInvoices={setInvoices}
                              setTotal={setTotal}
                              index={index}
                              setSelected={setSelected}
                              selected={selected}
                              setPaymentTotal={setPaymentTotal}
                              openInvoiceModal={openInvoiceModal}
                              handleOpenModal={handleOpenModal}
                              handleCloseModal={handleCloseModal}
                              key={row.id}
                            />
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{ height: (dense ? 33 : 53) * emptyRows }}
                        >
                          ...
                        </TableRow>
                      )}
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
          )}
          {isTabletOrMobile || state.invoices.length === 0 ? null : (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={state.invoices.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
          {isTabletOrMobile && state.invoices.length > 3 ? (
            <Button
              color="secondary"
              style={{ marginTop: 20 }}
              onClick={() => {
                if (rowsPerPage !== state.invoices.length) {
                  setRowsPerPage(state.invoices.length);
                } else {
                  setRowsPerPage(3);
                }
              }}
            >
              {rowsPerPage !== state.invoices.length
                ? "View All Invoices"
                : "Hide Invoices"}
            </Button>
          ) : null}
          <div style={{ width: '100%', textAlign: 'center', paddingTop: 25 }}>
						<a href={'/invoices'} style={{ color: '#1D9ADD' }}>
							Click here to see archived invoices
						</a>
								</div>
        </Paper> */
}
